// An invite URL (/i/<token>) carries a bearer token. Set a no-referrer policy
// synchronously, before React renders, as a defense in depth fallback for
// later client-side work. It cannot protect subresources fetched before this
// script runs; Vercel's response header must do that. A document's referrer
// policy persists once set, so this over-scrubs the rest of the SPA session;
// that is the intended trade.
// The match folds case on purpose: the guard must cover every spelling a
// browser can send, even though the /i/:token route itself is case-sensitive.
export const guardInviteReferrer = (doc, pathname) => {
  if (!/^\/i\//i.test(pathname)) return;
  if (doc.head.querySelector('meta[name="referrer"]')) return;
  const meta = doc.createElement('meta');
  meta.setAttribute('name', 'referrer');
  meta.setAttribute('content', 'no-referrer');
  doc.head.prepend(meta);
};
